import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from '@/components/App';
import { ErrorBoundary } from '@sentry/react';
import { StateMessage } from '@matrix-forge/ui/custom/StateMessage';
import './index.css';

// Initialize test helpers for Playwright E2E tests (dev/test mode only)
if (import.meta.env.DEV || import.meta.env.MODE === 'test') {
  import('./testHelpers').then(({ initializeTestHelpers }) => {
    initializeTestHelpers();
  });
}

const rootNode = document.getElementById('root');
if (rootNode) {
  createRoot(rootNode).render(
    <StrictMode>
      <ErrorBoundary
        fallback={
          <StateMessage
            isAbsolute
            isError
            title="Something went wrong."
            description="Please reload the page to try again."
          />
        }
      >
        <App />
      </ErrorBoundary>
    </StrictMode>
  );
} else {
  console.error('Studio: could not mount; "root" node not found.');
}
